import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {DefaultValuesByColumnType} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {Worksheet} from 'notebook/worksheets/WorksheetConstants';
import {toStudiesTypedValueFromSearchItems} from 'studies/StudiesTypedValueUtils';
import {StudySearchItem} from 'studies/StudySearchInput';

export function getStudySearchItemsFromWorksheet(worksheet: Worksheet | null): Array<StudySearchItem> {
  return (
    worksheet?.studies
      .filter((study) => !isInaccessible(study))
      .map((study) => ({
        id: study.id,
        humanId: study.humanId,
        name: study.name,
      })) ?? []
  );
}

export function getStudyDefaultValuesFromWorksheet(
  worksheet: Worksheet | null
): DefaultValuesByColumnType | undefined {
  const studies = getStudySearchItemsFromWorksheet(worksheet);
  return studies.length > 0
    ? {
        [TableColumnType.STUDIES]: {
          text: '',
          typedValue: toStudiesTypedValueFromSearchItems(studies),
        },
      }
    : undefined;
}
